import Datalibrary from "../Components/Data Library Management/Data Library/Datalibrary"
import Createnewdatalibrary from "../Components/Data Library Management/DataLibraryCreateNew/Createnewdatalibrary"
import AddInspection from "../Components/Inspection/Add Inspection/Addinspection"
import Inspectionlist from "../Components/Inspection/Inspection List/Inspectionlist"
import UpdateInspection from "../Components/Inspection/Update Inspection/UpdateInspection"
import Changepw from "../Components/Profile/Change Password/Changepw"
import Editprofile from "../Components/Profile/Edit Profile/Editprofile"
import Profiledetail from "../Components/Profile/Profile Details/Profiledetail"
import AddProject from "../Components/Project Management/Add Projects/Addprojects"
import ProjectDetails from "../Components/Project Management/Project Details/Projectdetails"
import ProjectListing from "../Components/Project Management/Project Listing/Projectlisting"
import UpdateProject from "../Components/Project Management/updateProject/UpdateProject"
import StartInspection from "../Components/Template/StartInspection/StartInspection"
import Templatelisting from "../Components/Template/TemplateListing/Templatelisting"
import Templatepage from "../Components/Template/TemplatePage/Templatepage"
import UpdateTemplate from "../Components/Template/UpdateTemplate/UpdateTemplate"
import ViewTemplate from "../Components/Template/view template/ViewTemplate"
import Updateuser from "../Components/User Management Flow/Update-User/Updateuser"
import Updatedetails from "../Components/Data Library Management/Update Details/Updatedetails"
import Inspectiondetails from "../Components/Inspection/Inspection Details/Inspectiondetails"

const OfficeAdminRoute = [

    // user route
    {
        path: "/update-user/:id",
        element: <Updateuser />,
    },

    // profile routes
    {
        path: '/user-profile',
        element: <Profiledetail />
    },
    {
        path: "/edit-user-profile",
        element: <Editprofile />
    },
    {
        path: "/settings",
        element: <Changepw />
    },



    // project management routesi
    {
        path: "/project-listing",
        element: <ProjectListing />
    },
    {
        path: "/add-project",
        element: <AddProject />
    },
    {
        path: "/view-project/:id",
        element: <ProjectDetails />,
    },
    {
        path: "/update-project/:id",
        element: <UpdateProject />,
    },


    // data library
    {
        path: "/datalibrary-listing",
        element: <Datalibrary />
    },
    {
        path: "/add-datalibrary",
        element: <Createnewdatalibrary />
    },
    {
        path: "/update-datalibrary/:id",
        element: <Updatedetails />
    },


    // Inspection
    {
        path: "/inspection-listing",
        element: <Inspectionlist />
    },
    {
        path: "/view-inspection/:id",
        element: <Inspectiondetails />
    },
    {
        path: "/add-inspection",
        element: <AddInspection />
    },
    {
        path: "/update-inspection/:id",
        element: <UpdateInspection />
    },
    {
        path: '/start-inspection/:id',
        element: <StartInspection />
    },


    //  template
    {
        path: "/template-listing",
        element: <Templatelisting />
    },
    {
        path: "/add-template",
        element: <Templatepage />
    },
    {
        path: '/update-template/:id',
        element: <UpdateTemplate />
    },
    {
        path: '/view-template/:id',
        element: <ViewTemplate />
    },

]

export default OfficeAdminRoute